import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabKentta from "./TabKentta";
import TabOmat from "./TabOmat";
import AdminView from "../Admin/AdminView";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { withRouter, RouteComponentProps } from "react-router-dom";
const muitheme = createMuiTheme({
  palette: {
    primary: {
      light: "#ff5f52",
      main: "#c62828",
      dark: "#8e0000",
      contrastText: "#fff",
    },
    secondary: {
      light: "#8e8e8e",
      main: "#616161",
      dark: "#373737",
      contrastText: "#fff",
    },
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
interface RouterProps {
  arena_number: string;
}
interface TabProps extends RouteComponentProps<RouterProps> {
  events: any;
  dateClick: any;
  eventClick: any;
  isAdmin: boolean;
}
const SimpleTabs = function SimpleTabs(props: TabProps) {
  const classes = useStyles();
  const [arena, setArena] = useState(props.match.params.arena_number);
  const handleChange = (event: any, newValue: React.SetStateAction<number>) => {
    props.history.push("/kentta/" + newValue.toString());
    setArena(newValue.toString());
  };

  return (
    <div className={classes.root}>
      <ThemeProvider theme={muitheme}>
        <AppBar position="static">
          <Tabs
            value={parseInt(arena)}
            onChange={handleChange}
            aria-label="arena tabs"
          >
            <Tab label="Kenttä 1" {...a11yProps(0)} value={1} />
            <Tab label="Kenttä 2" {...a11yProps(1)} value={2} />
            <Tab label="Kenttä 3" {...a11yProps(2)} value={3} />
            <Tab label="Omat varaukset" {...a11yProps(3)} value={4} />
            {props.isAdmin ? (
              <Tab label="Admin" {...a11yProps(4)} value={5} />
            ) : null}
          </Tabs>
        </AppBar>
        <TabKentta
          value={parseInt(arena)}
          index={0}
          arena={arena}
          events={props.events}
          dateClick={props.dateClick}
        ></TabKentta>
        <TabOmat
          value={parseInt(arena)}
          index={4}
          events={props.events}
          eventClick={props.eventClick}
        ></TabOmat>
        {props.isAdmin ? <AdminView index={5} value={parseInt(arena)} /> : null}
      </ThemeProvider>
    </div>
  );
};
export default withRouter(SimpleTabs);
